export default {
  customer: null
};